import { Aperture } from "lucide-react";

export function Loader({ label = "Loading", full = false }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-4 ${full ? "min-h-screen" : "py-24"}`} data-testid="loader">
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-gold/20 blur-xl animate-pulse" />
        <Aperture className="relative w-9 h-9 text-gold animate-spin" style={{ animationDuration: "2.4s" }} strokeWidth={1.5} />
      </div>
      <p className="text-sm text-muted-foreground tracking-wide">{label}…</p>
    </div>
  );
}
